import forEach from 'lodash/forEach';
import values from 'lodash/values';

import { currentTariffSummaryText } from '~/src/features/tariffBuilder/components/alerts/currentTariffSummaryText';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';

type TSummaryItem = {
    title: string,
    cost: number,
    oldCost?: number,
    period?: number,
}

export type TSummaryInfo = {
    groups: { header: string, cost: number, items: TSummaryItem[] }[],
    total: number,
    discount: number,
    discountValue: number,
    alert?: string,
};

const itemsMap = [
    { label: 'Услуги в тарифе', entities: [EEntity.speed, EEntity.tv, EEntity.onlineCinemas, EEntity.additional, EEntity.antivirus, EEntity.security] },
    { label: 'Оборудование в тарифе', entities: [EEntity.routers, EEntity.decoders] },
];

const getSummaryInfo = (state: TInitialState): TSummaryInfo => {
    // @todo: Better to decompose switch case scenario to different object, each responsible for specific type of SummaryInfo property
    // like a mono internet, but not a mono internet for the tariff constructor (it does not care for the tariff constructor ;-))
    let isTvSelected = false;

    const { currentTariff, currentStep } = state;

    const result = itemsMap.reduce<TSummaryInfo>((acc, item) => {
        const header = item.label;
        const items: TSummaryItem[] = [];
        let groupCost = 0;

        forEach(
            item.entities,
            entity => {
                switch (entity) {
                    case EEntity.speed: {
                        const selectedSpeed = state[EEntity.speed][state.selectedSpeed];

                        if (selectedSpeed || selectedSpeed === 0) {
                            const cost = selectedSpeed.price;

                            acc.total += cost;
                            groupCost += cost;

                            items.push({
                                title: `Скорость ${selectedSpeed.speed} Мбит/с`,
                                cost,
                            });
                        }

                        break;
                    }
                    case EEntity.routers: {
                        Object.values(state[EEntity.routers])
                            .filter(router => router.quantity > 0)
                            .forEach(router => {
                                const cost = router.costs[router.selectedCost].cost * router.quantity;
                                const titlePostfix = router.quantity > 1 ? ` x${router.quantity}` : '';

                                items.push({
                                    title: `${router.title}${titlePostfix}`,
                                    cost,
                                    period: router.selectedCost,
                                });

                                acc.total += cost;
                                groupCost += cost;
                            });

                        break;
                    }
                    case EEntity.decoders: {
                        Object.values(state[EEntity.decoders])
                            .filter(decoder => decoder.quantity > 0)
                            .forEach(decoder => {
                                const cost = decoder.costs[decoder.selectedCost].cost * decoder.quantity;
                                const titlePostfix = decoder.quantity > 1 ? ` x${decoder.quantity}` : '';

                                items.push({
                                    title: `${decoder.title}${titlePostfix}`,
                                    cost,
                                    period: decoder.selectedCost,
                                });

                                acc.total += cost;
                                groupCost += cost;
                            });

                        break;
                    }
                    case EEntity.tv: {
                        forEach(
                            state[EEntity.tv],
                            tvGroup => {
                                values(tvGroup.items)
                                    .filter(tvItem => tvItem.quantity > 0)
                                    .forEach(tvItem => {
                                        if (!isTvSelected) {
                                            isTvSelected = true;
                                        }
                                        const cost = tvItem.cost.final;

                                        items.push({
                                            title: tvItem.title,
                                            cost,
                                        });

                                        acc.total += cost;
                                        groupCost += cost;
                                    });
                            },
                        );

                        break;
                    }
                    case EEntity.services:
                    case EEntity.entertainments: return;
                    default: {
                        values(state[entity])
                            .filter(e => e.quantity > 0)
                            .forEach(i => {
                                const cost = i.cost.final * i.quantity;

                                items.push({
                                    title: i.title,
                                    cost,
                                });

                                acc.total += cost;
                                groupCost += cost;
                            });
                    }
                }
            },
        );

        if (items.length > 0) {
            acc.groups.push({
                header,
                cost: groupCost,
                items,
            });
        }

        return acc;
    }, { groups: [], total: 0, discount: state.discount.percent, discountValue: state.discount.value });

    const connectionCost = {
        header: 'Подключение',
        cost: isTvSelected ? 1001 : 1000,
        items: [],
    };

    if (!currentTariff) {
        result.groups.push(connectionCost);
        result.total += connectionCost.cost;
    }

    if (currentTariff && currentStep !== ESteps.Final) {
        result.alert = currentTariffSummaryText(currentTariff);
    }

    return result;
};

export default getSummaryInfo;
